<template>
  <div>
    <loading :active.sync="isLoading" color="#85344c"></loading>
    <div class="content-wrapper">
      <div class="container-fluid">
        <!-- Breadcrumbs-->
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <router-link to="/adm/uniodontos">Uniodontos</router-link>
          </li>
          <li class="breadcrumb-item active">Detalhes {{operadora.name}}</li>
        </ol>

        <div class="row">
          <div class="col-md-12" v-if="mostraErro">
            <div class="alert alert-danger alert-dismissible" role="alert">
              <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
              <strong>Ops!</strong>
              <span>{{erroMensagem}}</span>
            </div>
          </div>
        </div>

        <!-- Card da uniodonto -->
        <div class="box_general padding_bottom">
          <div class="header_box version_2">
            <h2>
              <i class="fa fa-info-circle"></i>Informações da Uniodonto
            </h2>
          </div>
          <div class="row">
            <div class="col-md-8">
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Nome uniodonto</label>
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Informe o nome da uniodonto"
                      v-model="operadora.name"
                    />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label>CNPJ</label>
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Informe o CNPJ"
                      v-model="operadora.cnpj"
                      v-mask="['##.###.###/####-##']"
                    />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Código ANS</label>
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Informe o código ANS"
                      v-model="operadora.ans"
                    />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Email notificação de vendas</label>
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Informe o e-mail que irá receber as notifcações de vendas"
                      v-model="operadora.email"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>Logo uniodonto</label>
                <input
                  type="file"
                  class="form-control"
                  placeholder="Informe a foto"
                  @change="trocaFoto"
                />
              </div>
              <img :src="imagem_foto" class="img-thumbnail" />
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>Telefone de Contato</label>
                <input
                  class="form-control"
                  v-model="operadora.telefone"
                  type="text"
                  placeholder="Telefone"
                  v-mask="['(##) #####-####','(##) ####-####']"
                />
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>Mazepag ID</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Informe o Mazepag ID"
                  v-model="operadora.mazepag_id"
                />
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>Mazepag Token</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Informe o Mazeapag Token"
                  v-model="operadora.mazepag_token"
                />
              </div>
            </div>


            <div class="col-md-4">
              <div class="form-group">
                <label>Mostrar dados cartão</label>
                <select
                  class="form-control"
                  v-model="operadora.recorrencia"
                >
                  <option value='' selected disabled>Selecione</option>
                  <option value='0' >SIM</option>
                  <option value="1">NÃO</option>
                </select>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>E-mail pagseguro</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Informe o email vinculado ao pagseguro"
                  v-model="operadora.pagseguro_email"
                />
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>Token Pagseguro</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Informe o token"
                  v-model="operadora.pagseguro_token"
                />
              </div>
            </div>
<!--             <div class="col-md-4">
              <div class="form-group">
                <label>Token Acesso</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Informe o token"
                  v-model="operadora.TokenAcesso"
                />
              </div>
            </div> -->
            <div class="col-md-4">
              <div class="form-group">
                <label>Url de Integração</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Informe a url"
                  v-model="operadora.url_integracao"
                />
              </div>
            </div>
            <div class="col-md-12">
              <div class="form-group">
                <label>Descrição Pós-Vendas</label>
                <vue-editor
                  v-model="operadora.texto_email_pos_venda"
                  :editorToolbar="customToolbar"
                  placeholder="Aqui você deve preencher com o conteúdo que deseja, que seja mostrado no e-mail de fechamento da compra. O mesmo texto será mostrado na página de fechamento do pedido"
                ></vue-editor>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12" v-if="erroCep">
              <div class="alert alert-danger alert-dismissible" role="alert">
                <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
                <div v-html="msgErroCep"></div>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label>CEP</label>
                <input
                  v-mask="'#####-###'"
                  type="text"
                  class="form-control"
                  placeholder="XXXXX-XXX"
                  v-model="endereco.cep"
                  @blur="procuraCep()"
                />
              </div>
            </div>
            <div class="col-md-2">
              <div class="form-group">
                <label>Estado</label>
                <input type="text" class="form-control" readonly v-model="endereco.uf" placeholder="Estado" />
              </div>
            </div>
            <div class="col-md-7">
              <div class="form-group">
                <label>Cidade</label>
                <input type="text" class="form-control" readonly v-model="endereco.localidade" placeholder="cidade" />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-5">
              <div class="form-group">
                <label>Bairro</label>
                <input type="text" class="form-control" v-model="endereco.bairro" placeholder="Bairro" />
              </div>
            </div>
            <div class="col-md-7">
              <div class="form-group">
                <label>Logradouro</label>
                <input type="text" class="form-control" v-model="endereco.logradouro" placeholder="Logradouro" />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3">
              <div class="form-group">
                <label>Número</label>
                <input type="text" class="form-control" v-model="endereco.numero" placeholder="Número" />
              </div>
            </div>
            <div class="col-md-9">
              <div class="form-group">
                <label>Complemento</label>
                <input type="text" class="form-control" v-model="endereco.complemento" placeholder="Complemento" />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <button href="#0" class="btn_1 medium pull-right" @click="edita_uniodonto('uniodonto')">Editar Uniodonto</button>
            </div>
          </div>
        </div>
        
        <!-- Card de usuário -->
        <div class="box_general padding_bottom">
          <div class="header_box version_2">
            <h2>
              <i class="fa fa-user"></i>Usuário de acesso
            </h2>
            <p>Gerencie sua credencial de acesso</p>
          </div>
          <div class="row">
            <div class="col-md-4">
              <div class="form-group">
                <label>Usuário de acesso</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Login de acesso"
                  v-model="operadora.login"
                />
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>Senha</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Senha de acesso"
                  v-model="password"
                />
              </div>
            </div>
            
            <div class="col-md-4">
              <button href="#0" class="btn_1 medium" @click="edita_usuario('usuario')">Editar Acesso</button>
            </div>
          </div>
        </div>

        <!-- Card de abrangência -->
        <div class="box_general padding_bottom">
          <div class="header_box version_2">
            <h2>
              <i class="fa fa-map"></i>Abrangência da sua Operadora
            </h2>
            <p>Adicione ou remova a cidade na lista abaixo</p>
          </div>
          <div class="row">
            <div class="col-md-12" v-if="erroCepAbrangencia">
              <div class="alert alert-danger alert-dismissible" role="alert">
                <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
                <strong>Ops!</strong>
                <span>{{msgErroCepAbrangencia}}</span>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label>CEP</label>
                <input
                  v-mask="'#####-###'"
                  type="text"
                  class="form-control"
                  placeholder="CEP cidade"
                  v-model="cepAbrangencia"
                  @blur="procuraCepAbrangencia()"
                />
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label>Estado</label>
                <input type="text" class="form-control" disabled v-model="estadoAbrangencia" />
              </div>
            </div>
            <div class="col-md-5">
              <div class="form-group">
                <label>Cidade</label>
                <input type="text" class="form-control" disabled v-model="cidadeAbrangencia" />
              </div>
            </div>
            <div class="col-md-1">
              <button href="#0" class="btn_1 mt-4" @click="addAbrangencia()">
                <i class="fa fa-plus"></i>
              </button>
            </div>
            <div class="col-md-12">
              <ul>
                <template v-if="abrangencia.length > 0">
                  <li :key="cidade.id" v-for="cidade of abrangencia">
                    {{cidade.estado}} - {{cidade.nome}}
                    <i
                      class="fa fa-times"
                      @click="rmAbrangencia(cidade.id)"
                    ></i>
                  </li>
                </template>
                <li v-else>
                  Nenhuma cidade acidionada
                </li>
              </ul>
            </div>
          </div>
        </div>

        <!-- /container-fluid-->
      </div>
    </div>
  </div>
</template>

<script>
import { ajax, tratamento_requisicao, alerta } from "@/utils/util";
import funcoesGerais from "@/assets/js/funcoes.js";
import axios from "axios";
import moment from "moment";
import { VueEditor } from "vue2-editor";
import { Money } from "v-money";
import { ReturnStringErrorByArrayOfErrors } from '../../../utils/util';

export default {
  mixins: [funcoesGerais],
  components: {
    VueEditor,
    Money,
  },
  data() {
    return {
      id_uniodonto: this.$route.params.id_uniodonto,
      cepAbrangencia: "",
      estadoAbrangencia: "",
      cidadeAbrangencia: "",
      imagem_foto: "",
      mostraErro: false,
      erroCepAbrangencia: false,
      isLoading: false,
      erroCep: false,
      msgErroCep: "",
      password: "",
      endereco: {
        cep: "",
        uf: "",
        localidade: "",
        logradouro: "",
        bairro: "",
        numero: "",
        complemento: "",
      },
      operadora: {},
      abrangencia: [],
    };
  },
  mounted() {
    var self = this;
    self.isLoading = true;
    ajax("get", "/operadoras/"+self.id_uniodonto+"/detalhes/adm")
      .then(response => {
        self.isLoading = false;
        self.endereco.cep = response.detalhes.end_cep;
        self.endereco.uf = response.detalhes.end_estado;
        self.endereco.localidade = response.detalhes.end_cidade;
        self.endereco.logradouro = response.detalhes.end_logradouro;
        self.endereco.bairro = response.detalhes.end_bairro;
        self.endereco.numero = response.detalhes.end_numero;
        self.endereco.complemento = response.detalhes.end_complemento;
        self.operadora = response.detalhes;
        self.operadora.login = response.detalhes.users.login;
        self.imagem_foto = response.detalhes.logo_src;
        self.operadora.logo_src = '';
        self.abrangencia = response.abrangencia;
      })
      .catch(error => {
        self.isLoading = false;
        tratamento_requisicao(error, this);
      });
  },
  methods: {
    edita_uniodonto(flag) {
      var self = this;
      self.operadora.end_cep = self.endereco.cep;
      self.operadora.end_estado = self.endereco.uf;
      self.operadora.end_cidade = self.endereco.localidade;
      self.operadora.end_logradouro = self.endereco.logradouro;
      self.operadora.end_bairro = self.endereco.bairro;
      self.operadora.end_numero = self.endereco.numero;
      self.operadora.end_complemento = self.endereco.complemento;

      var objRequest = new FormData();
      self.operadora.users = null;
      var item = self.operadora;
      for (var key in item) {
        if (item[key]) objRequest.append(key, item[key]);
      }

      self.isLoading = true;
      ajax("post", "/edit_operadoras/"+ self.id_uniodonto, objRequest)
        .then((response) => {
          self.isLoading = false;
          if(flag == 'usuario')
             alerta(
               "success",
               "Atualizado",
               "Acesso atualizado com sucesso!"
             );
          else
             alerta(
               "success",
               "Atualizado",
               "Uniodonto editada com sucesso!"
             );
          self.$router.replace(
            self.$route.query.redirect || "/adm/uniodontos"
          );
        })
        .catch((error) => {
          self.isLoading = false;
          tratamento_requisicao(error, this);
        });
    },
    edita_usuario() {
      var self = this;
      if (self.operadora.login && self.password) {
        self.isLoading = true;

        var objRequest = new FormData();
        objRequest.append('name', self.operadora.users.name)
        objRequest.append('login', self.operadora.login)
        objRequest.append('email', self.operadora.login)
        objRequest.append('password', self.password)

        ajax("put", "/usuarios/"+ self.operadora.users.id, objRequest)
        .then((response) => {
          self.isLoading = false;
          alerta(
            "success",
            "Atualizado",
            "Acesso atualizado com sucesso!"
          );
          self.$router.replace(
            self.$route.query.redirect || "/adm/uniodontos"
          );
        })
        .catch((error) => {
          self.isLoading = false;
          tratamento_requisicao(error, this);
        });
      } else {
        let erros = {};
        if (!self.operadora.login) erros.login = ["O campo login é obrigatório."];
        if (!self.password) erros.password = ["O campo senha é obrigatório."];
        alerta("warning", "Atenção", ReturnStringErrorByArrayOfErrors(erros));
      }
    },
    trocaFoto: function ($event) {
      this.operadora.logo_src = $event.target.files[0];
      this.imagem_foto = URL.createObjectURL(this.operadora.logo_src);
    },
    addAbrangencia() {
      var self = this;
      var user = JSON.parse(localStorage.getItem("token_adm_comprodonto"));
      if (user) {
        self.isLoading = true;

        if (self.cepAbrangencia) {
          var post = {
            nome: self.cidadeAbrangencia,
            estado: self.estadoAbrangencia,
            provider_id: self.operadora.id
          };

          ajax("post", "/cidades", post)
            .then((response) => {
              self.isLoading = false;
              self.abrangencia.push(response);
              self.cidadeAbrangencia = "";
              self.estadoAbrangencia = "";
              self.cepAbrangencia = "";
            })
            .catch((error) => {
              self.isLoading = false;
              self.erroCepAbrangencia = true;
              self.msgErroCepAbrangencia = "Cidade ja existente";
            });


        } else {
            alerta(
               "warning",
               "Atenção",
               "Informe o CEP!"
             );
        }
      } else {
        self.$router.replace(self.$route.query.redirect || "/");
      }
    },
    rmAbrangencia(idCidade) {
      var self = this;
      var user = JSON.parse(localStorage.getItem("token_adm_comprodonto"));
      if (user) {
        self.isLoading = true;
        ajax("delete", "/cidades/" + idCidade)
          .then((response) => {
            self.isLoading = false;
            let index = self.abrangencia.findIndex(x => x.id == idCidade);
            self.abrangencia.splice(index, 1);
          })
          .catch((error) => {
            self.isLoading = false;
            self.erroCepAbrangencia = true;
            self.msgErroCepAbrangencia = "Erro ao remover cidade.";
          });
      } else {
        self.$router.replace(self.$route.query.redirect || "/");
      }
    },
    procuraCep() {
      var self = this;
      if (self.endereco.cep.length == 9) {
        self.isLoading = true;
        self.erroCep = false;
        self.$http
          .get("https://viacep.com.br/ws/" + self.endereco.cep + "/json/")
          .then(res => res.json())
          .then(
            response => {
              self.isLoading = false;
              self.endereco = [];
              if (response.erro) {
                self.msgErroCep =
                  "<strong>Cep incorreto!</strong> Verifique o cep informado.";
                self.erroCep = true;
              } else {
                self.endereco = response;
              }
            },
            err => {
              self.isLoading = false;
              self.endereco = [];
              self.msgErroCep =
                "<strong>Erro na consulta!</strong> Tente novamente.";
              self.erroCep = true;
            }
          );
      } else {
        self.msgErroCep =
          "<strong>Cep incorreto!</strong> Verifique o cep informado.";
        self.erroCep = true;
      }
    },
    procuraCepAbrangencia() {
      var self = this;
      if (self.cepAbrangencia.length == 9) {
        self.isLoading = true;
        self.erroCepAbrangencia = false;
        self.$http
          .get("https://viacep.com.br/ws/" + self.cepAbrangencia + "/json/")
          .then(res => res.json())
          .then(
            response => {
              self.isLoading = false;
              if (response.erro) {
                self.msgErroCepAbrangencia =
                  "Cep incorreto, verifique o número informado.";
                self.erroCepAbrangencia = true;
              } else {
                self.cidadeAbrangencia = response.localidade;
                self.estadoAbrangencia = response.uf;
              }
            },
            err => {
              self.isLoading = false;
              self.endereco = [];
              self.msgErroCepAbrangencia = "Tente novamente.";
              self.erroCepAbrangencia = true;
            }
          );
      } else {
        self.msgErroCepAbrangencia =
          "Cep incorreto, verifique o número informado.";
        self.erroCepAbrangencia = true;
      }
    },
  },
};
</script>